import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss']
})
export class EducationComponent implements OnInit {
  safeURL; //youTube Video URL //

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService
    ) {

    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'CView Education Surveys provide valuable insights into areas like course feedback, student feedback, teacher feedback etc.' },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'Teachers survey app , Student survey , Transparent solution for education , Parent feedback , Course feedback , Survey for students' }
    ]);

    this.setTitle('Education Survey For School | Templates For Students');
    // End SEO Meta Description


     // You Tube Video Description
     this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/Tv6p2aULiZo?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
     // End You Tube Video Description    
  }


  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description


  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();  
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}
